(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adasatee-home-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-adasatee-slideshow]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    let activeIndex = 0;

    const show = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === activeIndex)));
    };

    root.querySelector('[data-previous]').addEventListener('click', () => {
      show(activeIndex - 1);
    });
    root.querySelector('[data-next]').addEventListener('click', () => {
      show(activeIndex + 1);
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.dot));
    }));
    show(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
